// Product feature types
import { z } from 'zod'
import type { TFunction } from '@kostbar/i18n'
import type { VatCode } from '@/api/types'

// VAT code options for select dropdown
export const VAT_CODE_OPTIONS: Array<{ value: VatCode; label: string }> = [
  { value: 'AT0', label: 'AT 0%' },
  { value: 'AT4_9', label: 'AT 4,9%' },
  { value: 'AT10', label: 'AT 10%' },
  { value: 'AT13', label: 'AT 13%' },
  { value: 'AT20', label: 'AT 20%' },
]

// Zod schema for product creation form
export const buildCreateProductSchema = (t: TFunction<'products'>) =>
  z.object({
    name: z
      .string()
      .min(1, t('validation.nameRequired'))
      .max(200, t('validation.nameMax')),
    publicName: z.string().max(200, t('validation.publicNameMax')).optional(),
    vatCode: z.enum(['AT0', 'AT4_9', 'AT10', 'AT13', 'AT20'], {
      message: t('validation.vatCodeRequired'),
    }),
    active: z.boolean(),
    temperatureChoice: z.boolean(),
    barcode: z
      .string()
      .max(64, t('validation.barcodeMax'))
      .regex(/^[0-9A-Za-z-]*$/, t('validation.barcodePattern'))
      .optional(),
  })

export type CreateProductFormData = z.infer<
  ReturnType<typeof buildCreateProductSchema>
>

// Zod schema for product update form
export const buildUpdateProductSchema = (t: TFunction<'products'>) =>
  z.object({
    name: z
      .string()
      .min(1, t('validation.nameRequired'))
      .max(200, t('validation.nameMax'))
      .optional(),
    publicName: z.string().max(200, t('validation.publicNameMax')).optional(),
    vatCode: z.enum(['AT0', 'AT4_9', 'AT10', 'AT13', 'AT20']).optional(),
    active: z.boolean().optional(),
    temperatureChoice: z.boolean().optional(),
    barcode: z
      .string()
      .max(64, t('validation.barcodeMax'))
      .regex(/^[0-9A-Za-z-]*$/, t('validation.barcodePattern'))
      .optional(),
  })

export type UpdateProductFormData = z.infer<
  ReturnType<typeof buildUpdateProductSchema>
>
